import pulse from '@finn-no/pulse-sdk';
import type { TrackerData } from '@finn-no/pulse-sdk/dist/types';
import type {
    Result,
    SuggestTracking,
} from '@finn-no/search-frontend-clients/suggest';

export function trackResultClick(
    result: Result,
    trackingData: SuggestTracking,
) {
    const updatedData = {
        ...trackingData,
        object: result.trackingObject,
    } as unknown as TrackerData;

    pulse.trackEvent(updatedData);
}
